// ============================================================================
// Navigation Menu Data — eFakt Frontend
// ============================================================================

import type { MenuItem } from "./types";

export const menuItems: MenuItem[] = [
  {
    id: "sale-documents",
    label: "Sale Documents",
    icon: "Banknote",
    children: [
      {
        id: "invoices",
        label: "Invoices (FA)",
        icon: "FileText",
        href: "/invoices",
      },
      {
        id: "fiscal-invoices",
        label: "Fiscal Invoices (FF)",
        icon: "Receipt",
        href: "/fiscal-invoices",
      },
      {
        id: "retail-sales",
        label: "Daily Retail Sale (SP)",
        icon: "ShoppingCart",
        href: "/retail-sales",
      },
      {
        id: "receipts",
        label: "Receipts (PA)",
        icon: "ReceiptText",
        href: "/receipts",
      },
      {
        id: "corrections",
        label: "Corrections (FK)",
        icon: "FileMinus2",
        href: "/corrections",
      },
      {
        id: "export-invoices",
        label: "Export Invoices (FE)",
        icon: "Globe",
        href: "/export-invoices",
      },
      {
        id: "wwd",
        label: "Intra-EU Delivery (WD)",
        icon: "Truck",
        href: "/wwd",
      },
      {
        id: "currency-invoices",
        label: "Currency Invoices (FW)",
        icon: "Coins",
        href: "/currency-invoices",
      },
      {
        id: "currency-corrections",
        label: "Currency Corrections (DK)",
        icon: "FileMinusIcon",
        href: "/currency-corrections",
      },
    ],
  },
  {
    id: "received",
    label: "Received Documents",
    icon: "Inbox",
    href: "/received",
  },
];
